import { Encoding, Guide } from '@mode-vegas/vegas';
import { ChartTypes } from '@mode/shared/contract-common';
import { ChartTranslator } from '../chart-translator';
import { SchemaModel } from '../schema-model';
import { clearTextChannel, makePctOfTotalField } from './translator-util';

export class PieTranslator implements ChartTranslator {
  private model: SchemaModel;

  constructor(schemaModel: SchemaModel) {
    this.model = schemaModel;
  }

  translateHighChartsToMuze(encoding: Encoding, format: Readonly<ChartTypes.ChartFormat>): Encoding {
    // Remove anything in text
    encoding = clearTextChannel(encoding);
    // Add it back if necessary
    if (format.showValues) {
      const guide = new Guide();
      const colorField = encoding.marks.properties.color.values[0];
      if (format.pieLabelsNotPercentages) {
        // Add the color field to the text
        if (colorField != null) {
          const textField = {
            variable: { type: colorField.variable.type },
            formula: colorField.formula,
          };
          encoding = guide.addEncFieldToSeries(encoding, textField, 'text', '*').encoding;
        }
      } else {
        const angleField = encoding.marks.properties.angle.values[0];
        if (angleField != null) {
          const compiledField = this.model.compileEncField(angleField);
          const pctOfTotalField = makePctOfTotalField(compiledField, colorField, false);
          encoding = guide.addEncFieldToSeries(encoding, pctOfTotalField, 'text', '*').encoding;
        }
      }
    }
    return encoding;
  }

  translateMuzeToHighCharts(encoding: Encoding): Encoding {
    // Remove anything in text
    return clearTextChannel(encoding);
  }

  formatRequiresEncodingUpdate(
    oldFormat: Readonly<ChartTypes.ChartFormat>,
    newFormat: Readonly<ChartTypes.ChartFormat>
  ): boolean {
    return (
      oldFormat.showValues !== newFormat.showValues ||
      oldFormat.pieLabelsNotPercentages !== newFormat.pieLabelsNotPercentages
    );
  }
}
